import { useState } from "react";
import ArtistJoin from "./Forms/ArtistJoin";
import AddProduct from "./AddProd";
import StripeConnectOnboarding from "./Forms/StripeConnect";
import { base64ToFile } from "../../utils";
import { useDispatch } from "react-redux";
import { Server2, UserProfileUpdate } from "../../redux/actions/auth/auth.actions";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TravelerJoin from "./Forms/TravelerJoin";
import { StepIndicator } from "../visualAids/StepIndicator";

export default function BusinessForm() {

  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [user, setUser] = useState(null);
  const dispatch = useDispatch();
  const prams = window.location.pathname;

  const handleShift = (s) => {
    if ( s !== 0 && !user)
    {
      toast.error(('Fill the form first'), {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return
    }

    setStep(s)
  }

  const handleSaveUser = async (user) => {
    toast.success(('User Created Successfully'), {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setUser(user)
    setStep(1)
  }

  const handleAddProduct = async (product) => {

    if (!user?._id) return

    const formData = new FormData();
    formData.append("userId", user?._id);
    formData.append("productName", product.productName);
    formData.append("description", product.description);
    formData.append("category", product.category);
    formData.append("subCategory", product.subCategory || "");
    formData.append("price", String(product.price));
    formData.append("taxCategory", product.taxCategory || "physical-general");
    formData.append("discount", String(product.discountPrice));
    formData.append("variants", JSON.stringify(product.variants));
    formData.append("sku", product.sku);
    formData.append("stock", product.stock.toString());
    formData.append("status", product.status);
    formData.append("type", product.type);
    formData.append("shipping", JSON.stringify(product.shipping));
    formData.append("seo", JSON.stringify(product.seo));
    product.images.forEach((base64, index) => {
      const file = base64ToFile(base64, `image-${index}.png`);
      formData.append("images", file);
    });

    var config = {
      method: "POST",
      url: Server2 + "/products/add",
      data: formData,
    };

    await axios(config).then((res) => {
      console.log(res)
      if (res.data?.message === 'Product added successfully'){
        toast.success((res?.data?.message), {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setTimeout(() => {
          setStep(2);
        }, 2000);
      }
    }).catch((error) => {
      console.log("I am Error", error);
    });

  };

  const handleCancelEdit = () => {};

  const handleFetchDetails = async () => {

    var config = {
      method: "POST",
      url: Server2 + "/stripe/connect-status",
      data: {userId: user?._id},
      headers: { "Content-Type": "application/json" },
    };

    await axios(config).then((res) => {
      if(res?.status === 200){
        console.log(res, 'fetch')
        dispatch(UserProfileUpdate(user?._id)).then((res) => {
          if(res?.payload?.user?.is_selling === true) 
            toast.success((res?.data?.message), {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setTimeout(() => {
              navigate('/login')
            }, 2000);
        })
      }
      else
        toast.success((res?.data?.message), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

    })
    .catch((error) => {
      console.log("I am Error", error);
    });

  };

  return (
    <div className="bg-light w-100 pb-4" style={{}}>

      <div className="mx-auto pt-3" style={{maxWidth:700}}>

        <div className="text-center img-logo mx-auto mb-2">
          <img src="/img/banner.jpg" alt="" className="img-fluid rounded-2" />
        </div>

        <div className='m-1 pt-2 pe-1'>
            <StepIndicator
              currentStep={step}
              steps={[
                "Tell us about yourself",
                "Create my Shop",
                "Add Payment Method",
              ]}
              onChangeStep={(e)=>{handleShift(e)}}
            />
          </div>

        { step === 0 ?

          prams === '/artist-join' ?
          <ArtistJoin saveUser={(u) => handleSaveUser(u)} user={user}/> :
          <TravelerJoin saveUser={(u) => handleSaveUser(u)} user={user}/>

        : step === 1 ? 

          <AddProduct onSave={(p)=> handleAddProduct(p)} onCancel={() => handleCancelEdit()}/>

        : step === 2 ?

          <div className="mx-auto flex-grow-1 flex-column d-flex" style={{maxWidth: 700, minHeight: '100dvh'}}>
            <StripeConnectOnboarding userId={user?._id} onConfirm={() => handleFetchDetails()}/>
          </div>

          : null

        }

        <ToastContainer />

      </div>

      {/* <Footer /> */}
      {/* <div className="mt-3"></div> */}
      {/* <div style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
        <button className="bg-white shadow-sm border-0 rounded-5 px-2">
          <LanguageSelector />
        </button>
      </div> */}
    </div>
  );
}